if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.showCarousel = false;
        this.modalContentLoaded = false;
        this.carouselInitPromise = null;
        this.initCarousels = this.initCarousels.bind(this);
      }

      connectedCallback() {
        this.modalTemplate = this.querySelector('template[data-product-modal-template]');
        this.modalContent = this.querySelector('.product-media-modal__content');
        this.showCarousel =
          this.querySelector('.main-carousel') != null ||
          this.modalTemplate?.content?.querySelector('.main-carousel') != null;
        this.mobileGutter = document.querySelector('.slider-mobile-gutter');
        this.mobileGutter?.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          this.show(this.openedBy);
        });
        super.removeEventListener('click', this.hide);
        this.initMainImageZoom();
      }

      initMainImageZoom() {
        const product = document.querySelector('.product__media-list');
        product.addEventListener('mousemove', (e) => {
          if (window.innerWidth < 750) return; // Disable zoom on mobile
          const productImage = product.querySelector('.is-active .product__media img');
          const rect = productImage.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;

          productImage.style.transformOrigin = `${x}% ${y}%`; // Set zoom origin
          productImage.style.transform = 'scale(2)'; // Zoom effect
        });

        product.addEventListener('mouseleave', () => {
          if (window.innerWidth < 750) return; // Disable zoom on mobile
          const productImage = product.querySelector('.is-active .product__media img');
          productImage.style.transform = 'scale(1)'; // Reset zoom
          productImage.style.transformOrigin = 'center'; // Reset origin
        });
      }

      initCarousels() {
        if (this.carouselInitPromise) return this.carouselInitPromise;
        if (!this.showCarousel || !this.querySelector('.main-carousel')) return Promise.resolve();

        this.carouselInitPromise = window.waitForMod('Swiper').then(() => {
          if (this.mainThumbnailSwiper) return;

        // Thumbnail Swiper
        this.thumbnailSwiper = new Swiper(".thumbnail-carousel", {
          spaceBetween: 10,
          slidesPerView: 6,
          freeMode: true,
          watchSlidesProgress: true,
          breakpoints: {
            1024: {
              slidesPerView: 6, // For desktops
            },
            768: {
              slidesPerView: 3, // For tablets
            },
            0: {
              slidesPerView: 2, // For mobile screens
            },
          },
        });

        // Main Swiper with conditional behavior
        this.mainThumbnailSwiper = new Swiper(".main-carousel", {
          spaceBetween: 10,
          zoom: true,
          navigation: {
            nextEl: ".thumbnail-button.swiper-button-next",
            prevEl: ".thumbnail-button.swiper-button-prev",
          },
          pagination: {
            el: ".main-carousel-pagination.swiper-pagination",
            clickable: true,
            dynamicBullets: true, // Optional: Makes bullets more compact
          },
          thumbs: {
            swiper: window.innerWidth > 750 ? this.thumbnailSwiper : null, // Only use thumbnails above mobile
          },
        });
        });

        return this.carouselInitPromise;
      }
      hide() {
        super.hide();
        if (!this.mainThumbnailSwiper) return;
        const selectedSlidePosition = this.mainThumbnailSwiper.realIndex + 1;
        const activeMediaThumbnailButton = document.querySelector(`.thumbnail-slider [data-media-position="${selectedSlidePosition}"] button`);
        activeMediaThumbnailButton?.click();
      }

      show(opener) {
        this.loadModalContent().then(() => {
          this.slideToSelectedMedia();
        });
        super.show(opener);
        // this.showActiveMedia();
      }

      loadModalContent() {
        if (!this.modalContentLoaded && this.modalTemplate && this.modalContent) {
          this.modalContent.appendChild(this.modalTemplate.content.cloneNode(true));
          this.modalTemplate.remove();
          this.modalContentLoaded = true;
        }

        return this.initCarousels();
      }

      slideToSelectedMedia() {
        if (!this.mainThumbnailSwiper) return;
        const selectedSlide = document.querySelector('.thumbnail-slider [data-media-position] .thumbnail[aria-current="true"]');
        if (!selectedSlide) return;
        let slidePosition = selectedSlide.closest('[data-media-position]').getAttribute('data-media-position');
        if (slidePosition) {
          slidePosition = parseInt(slidePosition) - 1;
          this.mainThumbnailSwiper.slideTo(slidePosition, 0);
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
